import { UsersPageThemeSizeConfig } from './types';

const large: UsersPageThemeSizeConfig = {
  usersPage: {},
};

export default large;
